var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Peer from "peerjs";
import { customAlphabet } from "nanoid";
import { CoreConnectionInstance } from "./CoreConnectionInstance.js";
import "../components/physics/Physics.js";
import "../components/types.js";
import "../enums-86f58524.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../global-33d5eebf.js";
import "../components/ComponentRegistry.js";
import "../utils/byteArray.js";
import "../components/entity/Types.js";
import "@dimforge/rapier2d-compat";
import "../console/flags.js";
import "../persist/persist.js";
import "../console/editor.js";
import "../console/floatingwindow.js";
import "lodash";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
import "pixi.js";
import "../FrameRate-7ce72a03.js";
import "../Collisions-9e9492fb.js";
import "../Physics-8d447f7a.js";
import "../game/GameModel.js";
import "../entity/EntityFactory.js";
import "../constants/index.js";
import "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "toposort";
import "../Parent-b4f1af10.js";
import "../components/core/ListenEntityCreation.js";
import "../Random-b6daba3a.js";
import "../SpatialMap-56228ece.js";
import "../ui/UIService.js";
import "../inputs/InputManager.js";
import "../utils/playSound.js";
import "../utils/md5.js";
import "../TimeDilation-41a74cd7.js";
import "../inputs/TouchListener.js";
import "../inputs/PlayerEventManager.js";
import "../game/GameCoordinator.js";
import "pixi-viewport";
import "../game/Ticker.js";
import "../PlayerInput-ad722e2d.js";
const nanoid = customAlphabet("234579ACDEFGHJKMNPQRTWXYZ", 10);
class PeerMultiplayerInstance extends CoreConnectionInstance {
  constructor(player, inputManager, { solohost, prefix, host, address = nanoid() }) {
    super(player, inputManager, { solohost });
    __publicField(this, "peer");
    __publicField(this, "connections", {});
    __publicField(this, "connectionPromise");
    __publicField(this, "prefix");
    __publicField(this, "selfAddress");
    __publicField(this, "handleData", (data) => {
      let [event, ...args] = data;
      if (event !== "frame") {
        console.log(event, args);
      }
      if (event === "peer") {
        const peerId = args[0];
        const player = args[1];
        if (!this.connections[peerId]) {
          const conn = this.peer.connect(peerId);
          this.handleConnection(conn);
        }
        if (!this.players.find((p) => p.netId === player.netId)) {
          this.players.push(player);
          this.handleData(["connect", player]);
        } else if (player.netId !== this.player.netId) {
          this.players = this.players.map((p) => p.netId === player.netId ? player : p);
          this.handleData(["reconnect", player]);
        }
        return;
      }
      if (this.onceSubscriptions[event]) {
        this.onceSubscriptions[event].forEach((callback) => {
          callback(...args);
        });
        this.onceSubscriptions[event] = [];
      }
      if (this.subscriptions[event]) {
        this.subscriptions[event].forEach((callback) => {
          callback(...args);
        });
      }
    });
    __publicField(this, "handleConnection", (conn) => {
      conn.on("data", (...data) => this.handleData(...data));
      conn.on("error", (err) => {
        console.error(err);
      });
      conn.on("open", () => {
        if (!this.connections[conn.peer]) {
          this.connections[conn.peer] = conn;
          if (!this.player.connected) {
            this.player.connected = true;
            this.player.connectionTime = Date.now();
            this.player.connectionId = this.peer.id;
            this.emit("peer", this.peer.id, this.player);
            this.handleData(["connect", this.player]);
          } else {
            this.players.forEach((player) => {
              this.emit("peer", player.connectionId, player);
            });
          }
        }
      });
      const handleDisconnect = () => {
        delete this.connections[conn.peer];
        const player = this.players.find((p) => p.connectionId === conn.peer);
        if (player) {
          this.players = this.players.filter((p) => p.connectionId !== conn.peer);
          this.handleData(["userDisconnect", player.netId]);
          if (this.players.length === 1) {
            this.player.connected = false;
            this.player.connectionTime = 0;
          }
        }
      };
      conn.on("iceStateChanged", (state) => {
        if (state === "disconnected") {
          handleDisconnect();
        }
      });
      conn.on("close", () => {
        handleDisconnect();
      });
    });
    this.prefix = prefix;
    this.address = address;
    if (!address.startsWith(this.prefix)) {
      address = this.prefix + address;
    }
    this.handshake(address, host);
  }
  async handshake(address, hostAddress) {
    this.selfAddress = address;
    if (hostAddress) {
      const host = hostAddress.split(":")[0];
      const port = parseInt((hostAddress.split(":")[1] || "443").split("/")[0]);
      const path = hostAddress.split("/")[1] || "/";
      this.peer = new Peer(address, {
        host,
        port,
        path,
        secure: true
      });
    } else {
      this.peer = new Peer(address);
    }
    let self_resolve;
    this.connectionPromise = new Promise((resolve) => {
      self_resolve = resolve;
      this.peer.on("open", (id) => {
        this.player.connectionId = id;
        console.log("My peer ID is: " + id);
        resolve();
      });
    });
    this.peer.on("connection", (conn) => {
      this.peer.off("error");
      this.handleConnection(conn);
    });
    this.peer.on("error", (err) => {
      console.log("peer error", err.message);
      this.peer.destroy();
      this.handshake(this.prefix + nanoid(), hostAddress).then(() => {
        self_resolve();
      });
    });
    await this.connectionPromise;
  }
  emit(event, ...args) {
    Object.entries(this.connections).forEach(([peerId, conn]) => {
      if (window.simulatedDelay) {
        setTimeout(() => {
          conn.send([event, ...args]);
        }, window.simulatedDelay);
      } else {
        conn.send([event, ...args]);
      }
    });
    if (event !== "message") {
      this.handleData([event, ...args]);
    }
  }
  async connect() {
    super.connect();
    let address = this.address;
    if (!address.startsWith(this.prefix)) {
      address = this.prefix + address;
    }
    await this.connectionPromise;
    if (this.selfAddress === address) {
      return;
    }
    const conn = this.peer.connect(address);
    return new Promise((resolve, reject) => {
      const failTimeout = setTimeout(() => {
        conn.close();
        reject("Connection timed out");
      }, 1e3);
      console.log(address, "connecting to host");
      this.handleConnection(conn);
      conn.once("open", () => {
        clearTimeout(failTimeout);
        this.connections[conn.peer] = conn;
        const player = this.player;
        if (player) {
          player.connected = true;
          player.connectionTime = Date.now();
          player.connectionId = this.peer.id;
        }
        this.emit("peer", conn.peer, player);
        resolve();
      });
    });
  }
}
export {
  PeerMultiplayerInstance
};
//# sourceMappingURL=PeerMultiplayerInstance.js.map
